function setBannerData(bannerHtml) {
   var bannerContainer = $E('.js-guide-promo-banner-container');
   if (bannerContainer) {
      bannerContainer.set('html', bannerHtml);
   }
}

onDomReady(function() {
   if (window.App.siteName != 'ifixit') {
      return;
   }

   var requestUri = 'internal/guide_banner_ad/' + App.guideid;

   new Request.API_2_0(requestUri, {
      onSuccess: setBannerData,
   }).send();
});
